import { render, staticRenderFns } from "./now.vue?vue&type=template&id=2c269c7a&"
import script from "./now.vue?vue&type=script&lang=js&"
export * from "./now.vue?vue&type=script&lang=js&"
import style0 from "./now.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports